import { useState, useEffect, PropsWithChildren } from 'react';
import {
  getInitialLanguage,
  getStoredLanguage,
  LanguageContext,
  LanguageEnum,
  storeLanguage,
  isMobile,
  isVisActorChineseDomain,
  isVisActorInnerDomain,
} from './utils';

import './global.less';

function App({
  children,
  hostname,
  userAgent,
}: PropsWithChildren<{ hostname: string; userAgent: string }>) {
  const [language, setLanguage] = useState<LanguageEnum>(
    () => getInitialLanguage(hostname)
  );
  useEffect(() => {
    setLanguage(getStoredLanguage(hostname));
  }, [hostname]);
  const languageValue = {
    language,
    setLanguage: (language: LanguageEnum) => {
      setLanguage(language);
      storeLanguage(language);
    },
    isVisActorChineseDomain: isVisActorChineseDomain(hostname),
    isVisActorInnerDomain: isVisActorInnerDomain(hostname),
    isMobile: isMobile(userAgent),
  };
  return (
    <LanguageContext.Provider value={languageValue}>
      {children}
    </LanguageContext.Provider>
  );
}
export default App;
